import mqtt from 'mqtt';

class MQTTWrapper {
    constructor() {
        let ip = window.localStorage.getItem('mqttapi');
        if(ip){
            var options = {
                // host: "http://" + ip,
                // port: ip ? Number(ip.split(":")[1]) : '',
                // endpoint: "/mqtt",
                clean: true, // 保留会话
                connectTimeout: 4000, // 超时时间
                reconnectPeriod: 4000, // 重连时间间隔
                // 认证信息
                clientId: "mqtt_clientId_" + new Date().getTime(),
                username: "admin",
                password: "public",
            };
            console.log("mqtt------", options)
            let url = "wss://" + ip + "/mqtt";
            this.client = mqtt.connect(url, options);
            this.subscriptions = {};
            this.client.on('connect', this.onConnect.bind(this));
            this.client.on('message', this.onMessage.bind(this));
        }else{
            console.log('mqtt地址信息为空')
        }
        
    }

    onConnect() {
        console.log('Connected to MQTT broker', this.client);
        Object.keys(this.subscriptions).forEach((topic) => {
            this.client.subscribe(topic);
        });
    }

    onMessage(topic, message) {
        if (this.subscriptions[topic]) {
            this.subscriptions[topic](message.toString());
        }
    }

    subscribe(topic, callback) {
        console.log(topic + ' is subscribed')
        this.subscriptions[topic] = callback;
        if (this.client.connected) {
            console.log(topic + ' is subscribed')
            this.client.subscribe(topic);
        }
    }

    unsubscribe(topic) {
        delete this.subscriptions[topic];
        if (this.client.connected) {
            this.client.unsubscribe(topic);
        }
    }

    publish(topic, message) {
        if (this.client.connected) {
            this.client.publish(topic, message);
        }
    }

    end() {
        this.client.end();
    }
}

export default MQTTWrapper;



// WEBPACK FOOTER //
// ./src/assets/js/mqttHandler.js